import { AuthResponse, OtpResponse } from "@/types/auth";
import { BaseService } from "../base.service";

class AuthService extends BaseService {
  constructor() {
    super("/users/auth");
  }

  // Auth endpoints
  async googleLogin(code: string): Promise<AuthResponse> {
    return this.post<AuthResponse>("/google-login", {
      code,
    });
  }

  async requestOtp(email: string): Promise<OtpResponse> {
    return this.post<OtpResponse>("/request-otp", {
      email,
    });
  }

  async verifyOtp(email: string, otp: string): Promise<AuthResponse> {
    return this.post<AuthResponse>("/verify-otp", {
      email,
      otp,
    });
  }
}

export const authService = new AuthService();
